"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Card_1 = require("./Card");
exports.AdsManagerBrochureAdCampaigns = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card_1.AdsManagerBrochureCard, { title: "Ad Campaigns", accentColor: "#643CB6", description: "Produce creatives, schedule, traffick, and execute on ad buys." },
            react_1.default.createElement(Card_1.AdsManagerBrochureCard.Feature, { icon: "calendar" }, "Schedule when and where ad campaigns run."),
            react_1.default.createElement(Card_1.AdsManagerBrochureCard.Feature, { icon: "edit" }, "Create and update campaign creatives."),
            react_1.default.createElement(Card_1.AdsManagerBrochureCard.Feature, { icon: "clipboardSuccess" }, "Manage who and how campaigns are approved and greenlit."))));
};
//# sourceMappingURL=AdCampaigns.js.map